module.exports = __webpack_public_path__ + "static/media/20.210076b6.png";